import { c as _c } from "react/compiler-runtime";
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import { Ribbon } from '@udemy-v2/react-notice-components';
import styles from './google-certificate-ribbon.module.scss';
import { useMemo } from 'react';
import { CareerAcceleratorsByCourseIds } from '@udemy-v2/career-accelerators';
import { getGoogleCareerPathUrl } from '@/features/course-landing-page/utils/google';

/**
 * Props for the GoogleCertificateRibbon component
 */
export interface GoogleCertificateRibbonProps {
  courseCareerAccelerator: CareerAcceleratorsByCourseIds | undefined;
  firstCourseId: string;
}

/**
 * Component that displays a ribbon indicating the course is part of a Google Certificate program.
 * Shows the current course number out of total courses and provides a link to the certificate page.
 */
export function GoogleCertificateRibbon(t0) {
  const $ = _c(15);
  const {
    courseCareerAccelerator,
    firstCourseId
  } = t0;
  const {
    gettext,
    interpolate
  } = useI18n();
  let t1;
  bb0: {
    if (!courseCareerAccelerator) {
      t1 = null;
      break bb0;
    }
    const accelerator = courseCareerAccelerator as unknown as {
      curriculum: {
        sections: Array<{
          items: Array<{
            id: string;
          }>;
        }>;
      };
      career: {
        name: string;
      };
      slug: string;
      stats?: {
        numberOfCourses?: number;
      };
    };
    const firstSection = accelerator.curriculum.sections[0];
    if (!firstSection) {
      t1 = null;
      break bb0;
    }
    const totalCourses = accelerator.stats?.numberOfCourses ?? 0;
    let t2;
    if ($[0] !== firstCourseId) {
      t2 = item => item.id === firstCourseId;
      $[0] = firstCourseId;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const currentCoursePosition = firstSection.items.findIndex(t2) + 1;
    const coursesInCurrentAccelerator = firstSection.items.length;
    let t3;
    if ($[2] !== accelerator.career.name || $[3] !== accelerator.slug || $[4] !== coursesInCurrentAccelerator || $[5] !== currentCoursePosition || $[6] !== totalCourses) {
      t3 = {
        careerName: accelerator.career.name,
        careerSlug: accelerator.slug,
        totalCourses,
        currentCoursePosition,
        coursesInCurrentAccelerator
      };
      $[2] = accelerator.career.name;
      $[3] = accelerator.slug;
      $[4] = coursesInCurrentAccelerator;
      $[5] = currentCoursePosition;
      $[6] = totalCourses;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t1 = t3;
  }
  const ribbonData = t1;
  let t2;
  if ($[8] !== gettext || $[9] !== interpolate || $[10] !== ribbonData) {
    t2 = ribbonData ? <LocalizedHtml html={interpolate(gettext("Course %(currentCourse)s/%(totalCourses)s of <a class=\"certificate-link\">%(careerName)s</a>"), {
      currentCourse: ribbonData.currentCoursePosition,
      totalCourses: ribbonData.totalCourses,
      careerName: ribbonData.careerName
    }, true)} interpolate={{
      "certificate-link": <a href={getGoogleCareerPathUrl(ribbonData.careerSlug)} className={styles["google-certificate-link"]} />
    }} /> : <LocalizedHtml html={interpolate(gettext("Included in <a class=\"certificate-link\">Learn AI with Google</a>"), true)} interpolate={{
      "certificate-link": <a href="/partner/google/learn-ai/" className={styles["google-certificate-link"]} />
    }} />;
    $[8] = gettext;
    $[9] = interpolate;
    $[10] = ribbonData;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const localizedHtml = t2;
  let t3;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon glyph="sparkles" size="xsmall" label={false} color="inherit" className={styles["icon-google"]} />;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== localizedHtml) {
    t4 = <div className={styles["google-certificate-ribbon"]}><Ribbon color="purple-150" className={styles["google-certificate-ribbon-inner"]}>{t3}{localizedHtml}</Ribbon></div>;
    $[13] = localizedHtml;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}